module.exports = __webpack_public_path__ + "img/karriere-v2.cca048b7.jpg";